//export default class Arrow {
//   constructor() {  
//     this.$sections = document.querySelectorAll('section.arrow');  
//   }
//}
//
//new Arrow();